<script setup lang="ts">
/**
 * BaseCard — components.css 의 .card / .card.feat 원자.
 *  default(.card): 흰 배경 + line 보더 + radius 14 + shadow-sm
 *  feat(.card.feat): 골드 강조 보더 + 골드 그림자(추천·선택 강조)
 * 색·그림자 모두 토큰 경유(shadow-accent-card).
 */
import { computed } from 'vue';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '#/lib/utils';

const cardVariants = cva('rounded-card bg-white p-6', {
  variants: {
    variant: {
      default: 'border border-line shadow-sm',
      feat: 'border-[1.5px] border-accent shadow-accent-card',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

type CardVariantProps = VariantProps<typeof cardVariants>;

interface Props {
  /** 시각 변형 — default(.card) / feat(.card.feat 골드 강조) */
  variant?: NonNullable<CardVariantProps['variant']>;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
});

const classes = computed(() => cn(cardVariants({ variant: props.variant })));
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
